import { useQuery } from '@tanstack/react-query';
import { questKeys } from '../quests.keys';
import { getBasicQuestInfo } from '../quests.service';
export const useBasicQuestInfo = (questId) => {
    return useQuery({
        queryKey: questKeys.basicQuestInfo(questId),
        queryFn: () => getBasicQuestInfo(questId),
        enabled: !!questId,
    });
};
